export default {
  functional: true,
  props: {
    url: {
      type: String,
      required: true
    },
    external: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    const { props: { url, external }, data } = context

    // 外部リンク
    if (external) {
      const anchorAttrs = { href: url, target: '_blank' }
      data.attrs = Object.assign({}, data.attrs, anchorAttrs)
      return h('a', data, context.children)
    }

    data.props = Object.assign({}, data.props, { to: url })
    return h('router-link', data, context.children)
  }
}
